import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/android/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/android/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/android/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/android/delete',
    method: 'post',
    data
  })
}

